import { render } from "./message-location.vue?vue&type=template&id=2ee98c02&scoped=true&ts=true"
import script from "./message-location.vue?vue&type=script&lang=ts"
export * from "./message-location.vue?vue&type=script&lang=ts"

import "./message-location.vue?vue&type=style&index=0&id=2ee98c02&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee98c02"]])

export default __exports__